import { z } from 'zod';
import { NOTE_TYPES } from '../types/agreementTimeline.types';
import { looksLikeCardNumber } from '../utils/looksLikeCardNumber';

export const NOTE_BODY_MAX_LENGTH = 5000;
export const CRM_CASE_ID_MAX_LENGTH = 100;

export const agreementNoteSchema = z
    .object({
        noteType: z.enum(NOTE_TYPES, { message: 'Choose a note type' }),
        body: z
            .string()
            .trim()
            .min(1, 'Enter the note')
            .max(NOTE_BODY_MAX_LENGTH, `Notes cannot exceed ${NOTE_BODY_MAX_LENGTH} characters`)
            .refine((value) => !looksLikeCardNumber(value), 'Notes must not contain a card number'),
        crmCaseId: z
            .string()
            .trim()
            .max(CRM_CASE_ID_MAX_LENGTH, `CRM case ID cannot exceed ${CRM_CASE_ID_MAX_LENGTH} characters`)
            .optional(),
    })
    .refine((values) => values.noteType !== 'case_action' || !!values.crmCaseId, {
        path: ['crmCaseId'],
        message: 'A case action needs a CRM case ID',
    });

export type AgreementNoteFormInput = z.input<typeof agreementNoteSchema>;
export type AgreementNoteFormValues = z.output<typeof agreementNoteSchema>;
